import {
  Instance_default
} from "./chunk-6SWJHUPL.js";
import {
  BaseRoute_default
} from "./chunk-QJTNIX2I.js";

// src/ContentX/Categories/ContentXCategoriesRoute.ts
var ContentXCategoriesRoute = class extends BaseRoute_default {
  constructor() {
    super(...arguments);
    this.option = "";
    this.getList = (filters) => {
      const buildFilters = this.createFilters(filters);
      return Instance_default.get(
        this.createRequestURL({
          option: "reditem",
          view: "category_with_org_check_aesirx_categories_69",
          ...buildFilters
        })
      );
    };
    this.getDetail = (id = 0) => {
      return Instance_default.get(
        this.createRequestURL({
          option: "reditem",
          view: "category_with_org_check_aesirx_categories_69",
          id
        })
      );
    };
    this.create = (data) => {
      return Instance_default.post(
        this.createRequestURL({
          option: "reditem",
          view: "category_with_org_check_aesirx_categories_69"
        }),
        data
      );
    };
    this.update = (data) => {
      return Instance_default.put(
        this.createRequestURL({
          option: "reditem",
          view: "category_with_org_check_aesirx_categories_69"
        }),
        data,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }
      );
    };
    this.delete = (ids) => {
      return Instance_default.delete(
        this.createRequestURL({
          option: "reditem",
          view: "category_with_org_check_aesirx_categories_69"
        }),
        {
          data: { ids: Array.isArray(ids) ? ids : [ids] }
        }
      );
    };
    this.createFilters = (filters) => {
      let buildFilter = {};
      for (const [key, value] of Object.entries(filters)) {
        if (typeof value === "object") {
          switch (value.type) {
            case "custom_fields":
              buildFilter["filter[" + value.type + "][" + key + "][]"] = value.value;
              break;
            case "filter":
              buildFilter["filter[" + key + "]"] = value.value;
              break;
            default:
              break;
          }
        } else {
          buildFilter[key] = value;
        }
      }
      return buildFilter;
    };
  }
};
var ContentXCategoriesRoute_default = ContentXCategoriesRoute;

export {
  ContentXCategoriesRoute_default
};
